import React, { useState } from 'react';
import axios from 'axios';
import download from 'downloadjs';

import { createNotification } from '../Notification';

const DownloadOrderPDFButton = ({ specimenId }) => {
  const [generating, setGenerating] = useState(false);

  const handleClick = async () => {
    console.log(`Generating order form for: ${specimenId}`);

    setGenerating(true);

    try {
      const data = { specimenId };
      const headers = {
        Authorization: `apikey ${process.env.REACT_APP_GENERATE_ORDER_PDF_API_KEY}`,
      };

      const response = await axios.post(process.env.REACT_APP_GENERATE_ORDER_PDF_URL, data, { headers });
      const contentType = response.headers['content-type'];
      download(response.data, `Req-${specimenId}.pdf`, contentType);
    } catch (error) {
      console.log('Order Form Generation', error);
      createNotification('danger', 'Error generating order PDF.');
    }

    setGenerating(false);
  };

  return (
    <button
      className="button is-info"
      onClick={handleClick}
      disabled={generating}
    >
      Order Form
    </button>
  );
};

export default DownloadOrderPDFButton;
